<template>
  <div>
    <div id="printTable">
      <div class="middle">
        <div class="middleL">会议信息</div>
        <div class="middleR middleR1">
          <div>
            <div>发起人： {{ data.principalName }}</div>
            <div>会议时间：{{ data.meetingStateTime }}</div>
            <div>会议主题：{{ data.meetingtTitle }}</div>
            <div>会议地点：{{ data.meetingLocationName }}</div>
          </div>
          <div>
            <div>签到开始时间：{{ data.meetingSignState }}</div>
            <div>签到结束时间：{{ data.meetingSignEnd }}</div>
            <div>邀请人员：{{ name }}</div>
            <div>
              <span>合计应到：{{ data.sysUserList ? data.sysUserList.length : null }}⼈</span>
              其中
              <span>准时签到{{ stateCount["1"] ? stateCount["1"] : 0 }}⼈</span>
              <span v-show="stateCount[2] ? true : false">
                迟到{{ stateCount["2"] }}⼈</span>
              <span v-show="stateCount[3] ? true : false">
                缺席{{ stateCount["3"] }}⼈</span>
            </div>
          </div>
        </div>
      </div>
      <div class="middle">
        <div class="middleL">会议记录</div>
        <div class="middleR">
          <Table :columns="tableCols" :data="data2" :table="table" :border="table.border" :stripe="table.stripe"
            :header="table.header" :footer="table.footer" :columns-list="tableCols">
          </Table>
        </div>
      </div>
    </div>
    <el-button style="margin-left: 10px" v-print="printObject" type="primary">打印</el-button>
    <div id="printArea" class="noprint">
      <meetingPrint :name="name" :data="data" :stateCount="stateCount" :data2="data2"></meetingPrint>
    </div>
  </div>
</template>

<script>
import uploadFile2 from "@/views/components/common/form/uploadFile2.vue";
import config from "@/../config";
import meetingPrint from '@/views/Meeting/operate/meetingPrint.vue'

export default {
  components: {
    uploadFile2,
    meetingPrint
  },
  data() {
    return {
      id: "",
      data: {},
      name: "",
      stateCount: {},
      printObject: {
        id: "printArea",
        popTitle: window.localStorage.getItem("customerName") + "服务报告",
        manualPageBreak: true,
      },
      table: {
        mname: "consumables",
        key: "id",
        url: {},
        output: false,
        border: true,
        rows: [],
        stripe: true,
        header: false,
        footer: false,
        order: "",
        router: {
          add: "",
          edit: "",
        },
      },
      tableCols: [
        {
          title: "记录人",
          key: "createBy",
          minWidth: 80,
          align: "center",
        },
        {
          title: "记录内容",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            return h("div", {
              domProps: {
                innerHTML: params.row.content,
              },
            });
          },
        },
        {
          title: "文件",
          minWidth: 120,
          align: "center",
          key: "recordFile",
          render: (h, params) => {
            const row = params.row;
            if (row.recordFile !== null) {
              return (
                <svg
                  onClick={() => {
                    this.handleRender(row.recordFile);
                  }}
                  t="1686795127586"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="7800"
                  width="20"
                  height="20"
                >
                  <path
                    d="M848.8576 199.1936H415.7568c0-26.5728-21.5424-48.128-48.128-48.128H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128V343.5648c0 26.5984 21.5424 48.1408 48.128 48.1408h673.728c26.5728 0 48.128-21.5424 48.128-48.1408v-96.2432c-0.0128-26.5856-21.5552-48.128-48.1408-48.128z"
                    fill="#CCA352"
                    p-id="7801"
                  ></path>
                  <path
                    d="M800.7424 247.3088H223.2576c-26.5728 0-48.128 21.5424-48.128 48.128v48.128c0 26.5984 21.5424 48.1408 48.128 48.1408h577.472c26.5728 0 48.128-21.5424 48.128-48.1408v-48.128c0-26.5728-21.5424-48.128-48.1152-48.128z"
                    fill="#FFFFFF"
                    p-id="7802"
                  ></path>
                  <path
                    d="M848.8576 295.4368H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128v481.2544c0 26.5472 21.5424 48.128 48.128 48.128h673.728c26.5728 0 48.128-21.568 48.128-48.128V343.552c-0.0128-26.5728-21.5552-48.1152-48.1408-48.1152z"
                    fill="#FFCC66"
                    p-id="7803"
                  ></path>
                </svg>
              );
            } else {
              return;
            }
          },
        },
      ],
      data2: [],
    };
  },
  created() {
    let query = this.$route.query;
    if (query) {
      this.id = query.id;
      this.initData();
      this.getminutes();
    }
  },
  methods: {
    handleRender(text) {
      const texturl = text.split(",");
      for (let i = 0; i < texturl.length; i++) {
        texturl[i] = config.IMAGE_HOST + texturl[i];
      }
      let files = texturl.map((texturl) => {
        const parts = texturl.split("#");
        return {
          url: parts[0],
          name: parts[1],
        };
      });
      this.$Modal.success({
        closable: true,
        title: `查看附件`,
        width: "400px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <List border size="small">
                {files.map((item) => {
                  return (
                    <ListItem>
                      <a href={item.url} target="_blank">
                        {item.name}
                      </a>
                    </ListItem>
                  );
                })}
              </List>
            </div>
          );
        },
      });
    },
    bindPrint() {
      this.printHtml("printTable");
    },
    printHtml(id_str) {
      var el = document.getElementById(id_str);
      var iframe = document.createElement("iframe");
      var doc = null;
      iframe.setAttribute(
        "style",
        "position:absolute;width:0px;height:0px;left:-500px;top:-500px;"
      );
      document.body.appendChild(iframe);
      doc = iframe.contentWindow.document;
      // 引入打印的专有css样式，www.111cn.net根据实际修改
      doc.write(
        "<style>html {font-family: SimSun;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;}body {margin: 10px;}#printTable {width: 700px;margin: 20px 0;}img {height: 140px;padding: 5px;}.top {font-size: 18px;width: 800px;overflow: hidden;}.left {width: 350px;float: left;}.right {width: 300px;float: right;text-align: right;}table {border-collapse: collapse;border-spacing: 0;font-size: 18px;}td, th {padding: 0;padding-left: 5px;}td{height: 35px;}.pure-table {border-collapse: collapse;border-spacing: 0;empty-cells: show;border: 1px solid #cbcbcb;}.pure-table caption {color: #000;font: italic 85%/1 arial, sans-serif;padding: 1em 0;text-align: center;}.pure-table td, .pure-table th {border-left: 1px solid #cbcbcb;border-width: 0 0 0 1px;font-size: inherit;margin: 0;overflow: visible;padding: 0.5em 1em;}.pure-table thead {background-color: #e0e0e0;color: #000;text-align: left;vertical-align: bottom;}.pure-table td {background-color: transparent;}.pure-table-bordered td {border-bottom: 1px solid #cbcbcb;}.pure-table-bordered tbody > tr:last-child > td {border-bottom-width: 0;}</style>"
      );
      doc.write("<p>" + el.innerHTML + "</p>");
      doc.close();
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    },
    async initData() {
      // 加载详情数据
      let id = this.id;
      $utils.api.load(`/admin/system/meeting/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.data = res.data;
          let userList = res.data.sysUserList;
          if (userList) {
            this.name = userList.map((obj) => obj.nickName).join(", ");
          }
          let arr = res.data.meetingSignResponseList;
          arr.forEach((item) => {
            let state = item.state;
            if (this.stateCount[state]) {
              this.stateCount[state]++;
            } else {
              this.stateCount[state] = 1;
            }
          });
        }
      });
    },
    async getminutes() {
      // 加载详情数据
      let q = { meetingId: this.id };
      $utils.api.load(`/admin/system/meeting/record/list`, q).then((res) => {
        if (res && res.rows) {
          console.log(res.rows);
          this.data2 = res.rows;
        }
      });
    },
    tominute() {
      $utils.url.push({ name: "minute" });
    },
  },
};
</script>

<style>
.noprint {
  display: none;
}

@media print {
  .noprint {
    display: block !important;
  }
}

.middle {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 3px 10px;
}

.middleL {
  width: 5%;
}

.middleR {
  width: 94%;
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.middleR1 {
  flex-direction: row;
  justify-content: flex-start;
}

.middleR1 :first-child {
  margin-right: 20px;
}
</style>
